import {mapKeys} from 'lodash'
import React from 'react'
import Text from 'react-text'
import Label from '../label'
import LessonLinks from '../lesson-links'
import {enhancedWithRowData, enhancedWithSortColumns} from '../../helpers/utils'

function CatalogueSearchHeader ({sortColumns, title}) {
  const active = sortColumns && sortColumns.id == title
  const direction = active ? (sortColumns.sortAscending ? 'ascending' : 'descending') : ''
  return (
    <span className="sorted-column-wrapper">
      <span className={direction}/>
      <span><Text id={`${title}_catalog_search_header`} /></span>
    </span>
  )
}

function EmptyHeader () { return (<span />) }

function LabelColumn (maxLength) {
  return ({value, sortColumns}) => {
    return <Label {...{value, maxLength}} />   
  }
}

function LessonColumn ({rowData}) {
  const {lesson, assigned} = rowData
  const assignedClass = `lesson-code${assigned ? ' assigned' : ''}`
  return (
    <div className={assignedClass}>
      <div className="bullet"></div>
      <div className="code">{lesson}</div>
    </div>
  )
}

function LessonLinksColumn ({rowData}) {
  const map = { lesson: 'id', lessonName: 'name'}
  const props = mapKeys(rowData, (_, key) => map[key] || key)
  return (<LessonLinks {...props} />)
}

const map = {
  headers: {CatalogueSearchHeader: enhancedWithSortColumns(CatalogueSearchHeader), EmptyHeader},
  columns: {
    LessonColumn: enhancedWithRowData(LessonColumn),
    LessonLinksColumn: enhancedWithRowData(LessonLinksColumn),
    LabelColumn
  }
}

export default map
